import React, { createContext, useEffect, useRef } from "react"
import {
    displayValues,
    formValues,
} from "../../Store/reducers/formReducer/initialState"
import styles from "./StepContainer.module.css"
import { StepContainerProps, StepContextType } from "./types"
import { getAdFormSteps } from "./AdFormSteps"
import { StepWrapper } from "./StepWrapper"
import { stepStatus } from "../../Store/reducers/stepReducer/initialState"

export const StepContext = createContext<StepContextType>({
    formState: formValues,
    displayState: displayValues,
    currentStep: 0,
    stepBoolean: stepStatus,
    handleNext: () => {},
    handlePrev: () => {},
    setFormValue: () => {},
    updateUserResume: () => {},
    setDisplayValue: () => {},
    setStepStatus: () => {},
    isBlocking: false,
    registerToken: undefined,
    offerId: undefined,
    offerInfo: undefined,
    handleRegistration: () => Promise.resolve({ status: "" }),
})

export const AdFormStepContainer = ({
    stepState,
    displayState,
    formState,
    handleNext,
    handlePrev,
    setFormValue,
    updateUserResume,
    setDisplayValue,
    setStepStatus,
    isBlocking,
    registerToken,
    offerId,
    offerInfo,
    handleRegistration,
}: StepContainerProps) => {
    const containerRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const container = containerRef.current
        if (!container) return

        const handleTabKey = (e: KeyboardEvent) => {
            if (e.key === "Tab") {
                e.preventDefault()
            }
        }

        container.addEventListener("keydown", handleTabKey)

        return () => {
            container.removeEventListener("keydown", handleTabKey)
        }
    }, [])

    const Steps = getAdFormSteps()

    const getStepComponent = (index: number) => {
        return Steps[index].Component
    }

    return (
        <div ref={containerRef}>
            {isBlocking && <div className={styles.blockingOverlay} />}

            <StepContext.Provider
                value={{
                    formState,
                    displayState,
                    currentStep: stepState.currentStep.currentStep,
                    stepBoolean: stepState.stepStatus,
                    handleNext,
                    handlePrev,
                    setFormValue,
                    updateUserResume,
                    setDisplayValue,
                    setStepStatus,
                    isBlocking,
                    registerToken,
                    offerId,
                    offerInfo,
                    handleRegistration,
                }}
            >
                <StepWrapper currentStep={stepState.currentStep.currentStep}>
                    {Steps.map((_, index) => {
                        const Component = getStepComponent(index)
                        return (
                            <div key={index} className={styles.stepContent}>
                                <Component />
                            </div>
                        )
                    })}
                </StepWrapper>
            </StepContext.Provider>
        </div>
    )
}
